
import { MqMaxWidthTabletXlarge } from '@Tokens/tokens.json';
import { FEATURED_GRID_VISIBLE } from '@Settings/product.settings';

export default {
  name: 'FeaturedProductsGrid',
  props: {
    /**
     * Card items
     * @see patterns/featured-product-card
     */
    cards: {
      type: Array,
      required: true,
    },
    /**
     * Section's title if any
     */
    title: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      hasLazyLoad: true,
      visibleItems: FEATURED_GRID_VISIBLE,
    };
  },
  computed: {
    cta() {
      let itemsLeft = this.cards.length - this.visibleItems;
      if (itemsLeft > FEATURED_GRID_VISIBLE) {
        itemsLeft = FEATURED_GRID_VISIBLE;
      }

      return {
        label: this.$tc('product.featuredProducts.cta', itemsLeft, {
          number: itemsLeft,
        }),
        layout: 'outline',
        size: 'l',
        variant: 3,
        icon: {
          name: 'chevron-down',
        },
        iconPosition: 'left',
      };
    },
    showMoreCta() {
      return (
        this.cards.length > FEATURED_GRID_VISIBLE &&
        this.cards.length > this.visibleItems
      );
    },
  },
  mounted() {
    this.$utils.breakpoint.listen(MqMaxWidthTabletXlarge, this.onResize);
  },
  beforeDestroy() {
    this.$utils.breakpoint.stop(MqMaxWidthTabletXlarge, this.onResize);
  },
  methods: {
    onResize(matches) {
      this.hasLazyLoad = matches;
    },
    showMore() {
      let visibleItems = this.visibleItems + FEATURED_GRID_VISIBLE;

      if (visibleItems > this.cards.length) {
        visibleItems = this.cards.length;
      }

      this.visibleItems = visibleItems;
    },
  },
};
